import ApiRequest from "../utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export const PARTNER_CATEGORIES = [
  { value: "STRATEGIC_PARTNER", label: "Strategic Partner" },
  { value: "SUPPORTED_BY", label: "Supported By" },
];

export function partnerCategoryLabel(value) {
  return PARTNER_CATEGORIES.find((c) => c.value === value)?.label ?? value ?? "-";
}

export default class Partner {
  static getAll = async () => {
    return await ApiRequest.set("v1/partners/getall", "GET");
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/partners/getbyid/${id}`, "GET");
  }

  static create = async (body) => {
    return await ApiRequest.set(`v1/partners/create`, "POST", body);
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/partners/update/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/partners/${id}`, "DELETE");
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/partners/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/partners/').downloadTemplate();
  };
}
